import axios from "axios";
import { IsAuthorized } from "src/authentication/IsAuthorized";
import { getJWT } from "src/helper/localStore/getJWT";

class ProcessServices {
    async editMirrorProcessByClient(id:number, body:any) {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_AUTH}/process/${id}`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
}

export const processServices = new ProcessServices()